import DeleteLocationDialoag from './DeleteLocationDialog';
export default DeleteLocationDialoag;
